import { appDependencies } from "../AppDependencies";
import { LocalStorageKeys } from "../app/LocalStorageKeys";
import { IRequestLanguageChange } from "./IRequestLanguageChange";
import { appEmit } from "../AppDomain";
import { EventNames } from "../events/Events";

import nl from "date-fns/locale/nl";
import { registerLocale, setDefaultLocale } from "react-datepicker";
registerLocale("nl-NL", nl);

export class LanguageService implements IRequestLanguageChange {
    protected defaultLanguage = "nl-NL";
    constructor() {
        setDefaultLocale(this.defaultLanguage);
    }
    public fromCacheOrDefault = async (): Promise<void> => this._loadCulture(await this.getCurrentLanguage());
    public changeLanguage = async (language?: string): Promise<boolean> => {
        language = language || this.defaultLanguage;
        appDependencies.ILocalRepository.store(LocalStorageKeys.currentLanguage, language);
        appEmit(EventNames.languageChanged);
        return this._loadCulture(language);
    }

    public getCurrentLanguage = async (): Promise<string> => await appDependencies.ILocalRepository.get<string>(LocalStorageKeys.currentLanguage) || Promise.resolve(this.defaultLanguage);
    public getCurrentLanguageSync = (): string => appDependencies.ILocalRepository.getSync<string>(LocalStorageKeys.currentLanguage) || this.defaultLanguage;
    private _loadCulture = async (culture: string): Promise<any> => await appDependencies.ICanTranslate.loadCulture(culture);
}
